import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import MyStorage from '../../common/MyStorage';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import SideMenu from '../../components/side-menu/SideMenu';
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { List } from 'react-content-loader'
import {Link} from 'react-router-dom'
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import { KMTracking } from '../../components/Tracking/KMTracking';

const MyListLoader = () => <List />
function Address(props) {
	const [givenName, setGivenName] = useState('')
	const [addresses, setAddresses] = useState(false)
	const [is_loading, setIsLoading] = useState(false)
	const [deliveryDataList, setDeliveryDataList] = useState<any>([])
	useEffect(() => {
		const storage = new MyStorage()
		let userID =  storage.getUserId();
		let accessToken =  storage.getaccess_token();
		const token = storage.getloggedIn()
		if (token == "true") {
			const given_name = storage.getName()?.split(' ')[0];
			setGivenName(given_name ? given_name : '')
		} else {
			props?.history?.push('/login',{from:'Address Book'})
		}
		if(userID && accessToken){
			seeCart()
		  }else{props?.history?.push("/login", { from: "Address Book" });}
		let eventData = {
			'location type': props?.location?.state?.from ? props.location.state.from :''
		}
		tracker('Opened Address Book Screen', eventData)

		fetchAddresses()
	}, [])
	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}
	const seeCart = async () => {
		let userID = await localStorage.getItem("UserId");
		let accessToken = await localStorage.getItem("access_token");
		await new WebApiCalls()
			.getCartDetail(userID, accessToken)
			.then(async (Response) => {
				if(Response.errorType){
					//redirect to login if expired
					props?.history?.push("/login", { from: 'Address Book' })
				}
			});
	};
	const fetchAddresses = async () => {
		setIsLoading(true)
		const storage = new MyStorage();
		// const contactId = storage.getContactIDFrasers();
		// const email = storage.getEmailFrasers();
		const authentication = storage.getauthenticationFrasers();
		let temparr2: any = [];
		await new WebApiCalls()
			.getAllAddress(authentication)
			.then((response) => {
				if (response.data) {
					response.data.all_addresses.map((item: any) => {
						if (item.is_default == "Y") {
							temparr2.unshift(item);
						} else {
							temparr2.push(item);
						}
					});
				}
			});
		if (temparr2.length > 0) {
			if(temparr2.length == 1 && temparr2[0].is_default == "N"){
				setToDefault(temparr2[0]?.address_id)
			}
			setDeliveryDataList(temparr2)
			setAddresses(true)
			setIsLoading(false)
		} else {
			setIsLoading(false)
			setAddresses(false)
		}
	};
	const setToDefault = async (_addr_id) => {
		const storage = new MyStorage()

		const contactId = storage.getContactIDFrasers();
		const authentication = storage.getauthenticationFrasers();

		let itemObj = {
			address_id: _addr_id,
			contact_id: contactId,
		};
		await new WebApiCalls()
			.setTodefault(itemObj, authentication)
			.then((response) => {
				if (response.statusCode) {
					fetchAddresses()
				}
			});
	};
	const deleteAddress = async (id) => {
        const contactId = localStorage.getItem('contactIDFrasers')
        // const email = localStorage.getItem('emailFrasers')
        const authentication = localStorage.getItem('authenticationFrasers')
        let itemObj = {
            address_id: id,
            contact_id: contactId,
        }
        await new WebApiCalls().deleteAddress(itemObj, authentication).then((response) => {
            if (response.statusCode) {
                fetchAddresses()
            }

        })
    }
	return (
		<div>
			<div className="viewport"></div>
			{/* /container */}
			<div className="container">
				{/* header */}
				<Header props={props} />
				{/* /header */}
				
				<MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
				{/* /content */}
				{addresses == true ?
					<div className="content">
						{/* breadcrumb-back */}
						<div className="breadcrumb-back">
							{/* breadcrumb */}
							<div className="breadcrumb" style={{ backgroundColor: "rgb(255,255,255,0.3)" }}>
								<Link to="/">Home</Link>
								<a href="#">Account</a>
								<a onClick={() => props?.history?.push('/address-book',{from: 'Address Book'})}>Address Book</a>
							</div>
							{/* /breadcrumb */}
							<a onClick={() => props?.history?.goBack()} className="backbtn">BACK</a>
						</div>
						{/* /breadcrumb-back */}
						{/* product listing */}
						<div className="account-page">
							{/* two-columns */}
							<div className="two-columns">
								{/* left panel */}

								<SideMenu props={props} />

								{/* /left panel */}
								{/* /right panel */}
								<div className="right-panel">
									{/* address book */}
									<div className="address-book">
										{/* title-add-wrap */}
										<div className="title-add-wrap">
											<a onClick={() => { props?.history?.push("add-address") }} className="blackbutton">ADD NEW</a>
										</div>
										{/* /title-add-wrap */}
										{/* address-list */}
										<div className="address-list">
											{/* entry */}
											{deliveryDataList?.length > 0 && deliveryDataList?.map((item: any, index: number) => {
												return (
													<div key={index} className="entry">
														{/* info */}
														<div className="info">
															<div className="name">{item?.contact_name} {item?.is_default == "Y" ? <span>(Default)</span> : ""}</div>
															<div className="address">
																{item?.street_name + " " + item?.building_name}<br />
																Singapore {item?.postal_code}
															</div>
														</div>
														{/* /info */}
														{item?.is_default !== "Y" &&
															<a onClick={() => {
																setToDefault(item?.address_id)
															}}>Make Default</a>}
														<a onClick={() => { props?.history?.push("/add-address", { editAddress: true, item }) }}>Edit</a>
														<a  onClick={() => {
														deleteAddress(item.address_id)
													}}>Delete</a>
													</div>
												)
											})}
											{/* /entry */}
										</div>
										{/* /address-list */}
									</div>
									{/* /address-book */}
								</div>
								{/* /right panel */}
							</div>
							{/* /two-columns */}
						</div>
						{/* /product listing */}
					</div>
					:
					<div className="content">
						{/* breadcrumb-back */}
						<div className="breadcrumb-back">
							{/* breadcrumb */}
							<div className="breadcrumb">
								<a onClick={() => props?.history?.push('/')}>Home</a>
								<a href="#">Account</a>
								<a onClick={() => props?.history?.push('/address-book',{from:'Address Book'})}>Address Book</a>
							</div>
							{/* /breadcrumb */}
							<a onClick={() => { props?.history?.goBack() }} className="backbtn">BACK</a>
						</div>
						{/* /breadcrumb-back */}
						{/* product listing */}
						<div className="account-page">
							{/* two-columns */}
							<div className="two-columns">
								{/* left panel */}
								<SideMenu props={props} />
								{/* /left panel */}
								{/* /right panel */}
								<div className="right-panel">
									{is_loading ? <MyListLoader /> :
										<div className="no-order">
											You do not have any saved addresses.<br />
											<span>Add an address to let us know where you’ll like to receive your deliveries.</span>
											<br /><br />
											<a onClick={() => { props?.history?.push("add-address",{zeroAddress: true}) }} className="blackbutton">ADD NEW</a>
										</div>}
								</div>
								{/* /right panel */}
							</div>
							{/* /two-columns */}
						</div>
						{/* /product listing */}
					</div>}
				{/* /content*/}
			</div>
			<Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
		</div>
	)
}
const mapStateToProps = (state) => {
	const { cart_count,allCategories } = state.UserReducer
	return { cart_count,allCategories }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount
};
export default connect(mapStateToProps, actions)(Address);